export default "__VITE_ASSET__DFuKaURa__"